import React from "react";
import { Trans } from "react-i18next";
import { t } from "js/i18n";
const BrowseLink = (props: { onBrowse: () => void; children?: React.ReactNode }) => (
    <a onClick={props.onBrowse}>{props.children}</a>
);
type Props = {
onBrowse: () => void;
};

export function CopySlideNoticeMessage({ onBrowse }: Props) {
    return (
        <Trans
            i18nKey="Search for the slide you need or <browseLink>browse</browseLink> your presentations."
            components={{ browseLink: <BrowseLink onBrowse={onBrowse} /> }}
        />
    );
}
